import React, { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { css } from '@emotion/css';
import {
  Box,
  Button,
  Card,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  FormControl,
  Select,
  MenuItem,
  TextField
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import { GET_REGISTRY_FOR_PICKUP, GET_ONLINE_ORDER_BY_WISHLIST_ID } from "../api/queries";
import { useApolloClient, useMutation } from "@apollo/client";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import numeral from "numeral";
import format from "date-fns/format";
//import TrTidDialog from "./TrTidDialog";
import { addDays, isAfter } from "date-fns";
import MessageIcon from "@mui/icons-material/Message";
import Popover from "@mui/material/Popover";
import { PAYMENT_TYPE, getStatusLabel } from "../../../constants";
import { AppContext } from "../../core/AppContext";
import { SEARCH_GIFT_WRAP } from "../../giftwrap/api/queries";
import { UPDATE_SHOPIFY_CHECKOUT_STATUS } from "../../registry/api/mutations";
import AddShopifyCheckoutRemarks from '../components/AddShopifyCheckoutRemarks'

const useStyles = () => ({
  root: css({
    flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
    padding: 20,
  }),
  card: css({
    padding: 15,
  }),
  orderDetail: css({
    display: "flex",
    flexDirection: "row",
    width: "100%",
  }),
  orderItems: css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
  }),
  tableIndex: css({
    fontWeight: "bold",
    textAlign: "center",
  }),
  table: css({
    width: "100%",
  }),
  label: css({
    width: "30%",
    fontWeight: "800",
    verticalAlign: "top",
  }),
  value: css({
    width: "70%",
    verticalAlign: "top",
  }),
  cartItemTable: css({
    fontSize: "10pt",
    marginTop: 30,
    width: "100%",
    borderCollapse: "collapse",
  }),
  cartItemQty: css({
    width: "5%",
    padding: ".50rem",
    verticalAlign: "top",
    display: "table-cell",
  }),
  tr: css({
    display: "table-row",
  }),
  th: css({
    padding: ".50rem",
    verticalAlign: "top",
    display: "table-cell",
  }),
  cartItemCode: css({
    width: "15%",
    padding: ".50rem",
    verticalAlign: "top",
    display: "table-cell",
  }),
  cartItemDesc: css({
    width: "20%",
    padding: ".50rem",
    border: "1px solid #dee2e6",
    verticalAlign: "top",
    display: "table-cell",
  }),
  cartItemPrice: css({
    width: "5%",
    padding: ".50rem",
    border: "1px solid #dee2e6",
    verticalAlign: "top",
    display: "table-cell",
    textAlign: "right",
  }),
  cartItemDiscount: css({
    width: "5%",
    textAlign: "right",
    padding: ".50rem",
    verticalAlign: "top",
    display: "table-cell",
  }),
  cartItemAmt: css({
    width: "5%",
    textAlign: "right",
    padding: ".50rem",
    verticalAlign: "top",
    display: "table-cell",
  }),
  actions: css({
    width: "5%",
    textAlign: "right",
    padding: ".50rem",
    verticalAlign: "top",
    display: "table-cell",
  })
});

const useRowStyles = () => ({
  root: css({
    "& > *": {
      borderBottom: "unset",
    },
  }),
  tableIndex: css({
    fontWeight: "bold",
    textAlign: "center",
  }),
  image: css({
    width: 60,
    height: "auto",
  }),
  typography: css({
    padding: 2,
    whiteSpace: "pre-wrap",
  })
});

let STATUSES = [
  {
    text: 'DELIVERED',
    value: 'DELIVERED'
  }
]

let ACTIVE_STATUSES = STATUSES

const Row = (props) => {
  let { checkoutRow, idx, doFetchData, giftWraps, registry, reload } = props;
  const [open, setOpen] = useState(false);
  const [checkout, setCheckout] = useState();
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false)
  const [pickCompleted, setPickCompleted] = useState(false);
  const [openTr, setOpenTr] = useState(false);
  const classes = useRowStyles();
  const [init, setInit] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const [isEditStatus, setIsEditStatus] = useState(false);
  const [doUpdateShopifyCheckoutStatus] = useMutation(UPDATE_SHOPIFY_CHECKOUT_STATUS);
  const { showSnackBar } = useContext(AppContext);

  const isPickCompleted = (updatedCheckout) => {
    const pickIndex = updatedCheckout.checkoutItems.findIndex((el) => el.picked === 0);
    if (pickIndex === -1) {
      setPickCompleted(true);
    } else {
      setPickCompleted(false);
    }
  };

  const initialize = () => {
    if (!init) {
      isPickCompleted(checkoutRow);
      setInit(true);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const dedicationOpen = Boolean(anchorEl);

  useEffect(() => {
    if (!checkout) {
      setCheckout(checkoutRow);
      // doFetchData()
      initialize();
    }
  }, [checkoutRow]);

  const giftWrap = giftWraps.reduce((selectedWrap, wrap) => {
    if (wrap.isDefault) {
      selectedWrap = wrap;
    }
    if (wrap._id == checkoutRow.giftWrap) {
      selectedWrap = wrap;
    }
    return selectedWrap;
  }, {});

  const doSaveCheckoutStatus = async (checkout, evt) => {
    checkout.orderStatus = evt.target.value

    const { loading } = await doUpdateShopifyCheckoutStatus({
      variables: {
        shopifyCheckoutId: checkout.checkout.order.orderId ? checkout.checkout.order.orderId : checkout?._id,
        status: checkout.orderStatus,
      },
    });
    if (!loading) {
      setOpen(false);
      doFetchData();
      showSnackBar({
        open: true,
        message: "Status successfully updated!",
        severity: "info",
      });
    }
  };

  // if(registry?.isPickup){
  //   ACTIVE_STATUSES = STATUSES.filter((v) => v.text !== 'DELIVERED')
  // }

  // // console.log('checkout?.orderStatus', checkout?.orderStatus)
  // if(['CONFIRMED','TO_RECEIVE','DELIVERED','COMPLETED'].includes(checkout?.orderStatus)){
  //   ACTIVE_STATUSES = STATUSES.filter((v) => v.value !== 'TO_PAY')
  // } 

  return (
    <>
      {checkout ? (
        <Fragment>
          <TableRow key={idx}>
            <TableCell>
              <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </TableCell>
            <TableCell onClick={() => setOpen(!open)} align="center">
              {checkout?.checkout?.order?.orderNumber}
            </TableCell>
            <TableCell onClick={() => setOpen(!open)} align="center">
              {checkout?.checkout?.order?.trackingNumber}
            </TableCell>
            <TableCell onClick={() => setOpen(!open)} align="center">
              {format(new Date(checkout.checkout.createdAt), "MMM dd, yyyy")}
            </TableCell>
            <TableCell onClick={() => setOpen(!open)} align="left">
              {checkout.customer ? checkout.customer.firstName : ""}{" "}
              {checkout.customer ? checkout.customer.lastName : ""}
            </TableCell>
            <TableCell onClick={() => setOpen(!open)} align="center">
              { checkout?.paymentTransactions?.transactions ? checkout?.paymentTransactions?.transactions[0]?.gateway : ''}
            </TableCell>
            {/* <TableCell>
              {checkout.tr || ""} / {checkout.tid || ""}
            </TableCell> */}
            <TableCell onClick={() => setOpen(!open)} align="right">
              {"₱"+numeral(checkout?.availableShippingRates?.shippingRates?.[0]?.price?.amount).format("0,000.00")}
            </TableCell>
            <TableCell onClick={() => setOpen(!open)} align="right">
              {"₱"+checkout.checkout.totalPrice.amount}
            </TableCell>
            <TableCell align="center">
              {
                isEditStatus ? 
                <FormControl variant="outlined">
                  <Select
                    name="subType"
                    onChange={(evt) => { 
                      doSaveCheckoutStatus(checkout, evt)
                      setIsEditStatus(!isEditStatus)
                    }
                  }
                    value={checkout.orderStatus}
                  >
                    {
                      checkout.orderStatus !== 'DELIVERED' && (
                        <MenuItem value={checkout.orderStatus} disabled>
                          {checkout.orderStatus}
                        </MenuItem>
                      )
                    }
                    {ACTIVE_STATUSES.map((status) => (
                      <MenuItem key={status.value} disabled={checkout.orderStatus !== 'DELIVERED' && status.text === 'DELIVERED' ? false : true } value={status.value}>
                        {status.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> :
                getStatusLabel(checkout.orderStatus)
              } 
              
              { !isEditStatus ?
                <IconButton
                  aria-label="delete"
                  onClick={() => setIsEditStatus(!isEditStatus)}
                >
                  <EditIcon /> 
                </IconButton> : <IconButton
                  aria-label="cancel"
                  onClick={() => setIsEditStatus(!isEditStatus)}
                >
                  <CancelIcon /> 
                </IconButton>
              }
            </TableCell>
            <TableCell onClick={() => setOpen(!open)} align="center">
              { checkout?.guestBarcode}
            </TableCell>
            <TableCell onClick={() => setOpen(!open)} align="center">
              { checkout?.remarks } 
                <IconButton
                  aria-label="edit"
                  onClick={() => setUpdateDialogOpen(!updateDialogOpen)}
                >
                  <EditIcon /> 
                </IconButton>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0, backgroundColor: "rgb(232, 248, 255)" }} colSpan={12}>
              <Collapse in={open} timeout="auto" unmountOnExit style={{}}>
                <Box margin={1}>
                  <h3>Items for picking</h3>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell width={5} />
                        <TableCell className={classes.tableIndex}>Quantity</TableCell>
                        <TableCell className={classes.tableIndex}>Product</TableCell>
                        <TableCell className={classes.tableIndex}>Item Price</TableCell>
                        <TableCell className={classes.tableIndex}>Gross Amount</TableCell>
                        <TableCell className={classes.tableIndex}>Discount</TableCell>
                        <TableCell className={classes.tableIndex}>Net Amount</TableCell>
                        <TableCell className={classes.tableIndex}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {checkout.checkoutItems.map((checkoutItem, i) => (
                        <TableRow key={i}>
                          <TableCell>
                            <img className={classes.image} src={checkoutItem.image || "/static/no-image.jpg"} />
                          </TableCell>
                          <TableCell align="center">{numeral(checkoutItem.node.quantity).format("0,000")}</TableCell>
                          <TableCell align="center">
                            {checkoutItem.node.title ?? checkoutItem.productName} <br />
                            {checkoutItem.node.variant.sku ?? checkoutItem.skuCode}
                          </TableCell>
                          <TableCell align="center">
                            &#8369;
                            {numeral(checkoutItem?.node?.variant?.price?.amount).format("0,000.00")}
                          </TableCell>
                          <TableCell align="center">
                            &#8369;
                            {numeral(checkoutItem?.node?.variant?.price?.amount * checkoutItem.node.quantity).format("0,000.00")}
                          </TableCell>
                          <TableCell align="center">
                            &#8369;{numeral(checkoutItem?.node?.discountAllocations?.[0]?.allocatedAmount.amount).format("0,000.00")}
                          </TableCell>
                          <TableCell align="center">
                            &#8369;
                            { 
                              (numeral((checkoutItem?.node?.variant?.price?.amount * checkoutItem.node.quantity) - Number(checkoutItem?.node?.discountAllocations?.[0]?.allocatedAmount?.amount ?? 0)).format("0,000.00"))
                            }
                          </TableCell>
                          <TableCell>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
                <TableRow style={{ display: "flex", justifyContent: "start" }}>
                  <TableCell>
                    <Box margin={1}>
                      <p>Gift Message</p>
                      {checkout.dedication}
                    </Box>
                  </TableCell>
                </TableRow>
              </Collapse>
            </TableCell>
          </TableRow>
          <AddShopifyCheckoutRemarks 
            checkout={checkout}
            updateDialogOpen={updateDialogOpen}
            setUpdateDialogOpen={setUpdateDialogOpen}
            reload={reload}
            doFetchData={doFetchData}
          />
          {/* <TrTidDialog
            openTr={openTr}
            setOpenTr={setOpenTr}
            checkout={checkoutRow}
            setCheckout={setCheckout}
            doFetchData={doFetchData}
          /> */}
        </Fragment>
      ) : null}
    </>
  );
};

const PickList = (props) => {
  const { showProgressIndicator } = useContext(AppContext);
  const { id, packed, pickComplete, registry, setRegistry } = props;
  const classes = useStyles();
  const [checkouts, setCheckouts] = useState(null);
  const [isOpenConfirmPack, setIsOpenConfirmPack] = useState(false);
  const client = useApolloClient();
  const [disabled, setDisabled] = useState(true);
  const [isForPicking, setIsForPicking] = useState(false);
  const [giftWrapList, setGiftWrapList] = useState([]);

  const doFetchData = async () => {
    try {
      showProgressIndicator(true);
      const { data, loading } = await client.query({
        query: GET_ONLINE_ORDER_BY_WISHLIST_ID,
        variables: { id },
        fetchPolicy: "network-only",
      });

      if (!loading && data.getOnlineOrdersByWishlistId) {
        const { getOnlineOrdersByWishlistId } = data;
        showProgressIndicator(false);
        setCheckouts(JSON.parse(getOnlineOrdersByWishlistId));
        return JSON.parse(getOnlineOrdersByWishlistId)
      }
    } catch (e) {}
    showProgressIndicator(false);
  };

  const fetchGiftWraps = async () => {
    try {
      showProgressIndicator(true);
      const { data, loading } = await client.query({
        query: SEARCH_GIFT_WRAP,
        variables: {
          searchInput: {},
          cursor: 0,
          order: "asc",
          orderBy: "productName",
          limit: 10,
        },
        fetchPolicy: "network-only",
      });

      if (!loading) {
        const { giftWraps } = JSON.parse(data?.searchGiftWrap);
        setGiftWrapList(giftWraps);
      }
    } catch (e) {}
    showProgressIndicator(false);
  };

  const fetchData = useCallback(async () => {
    if (!checkouts) {
      await doFetchData();
    }
    if (!giftWrapList || giftWrapList.length == 0) {
      fetchGiftWraps();
    }
  });

  const checkTrDetailsComplete = () => {
    if (checkouts) {
      const isCompleteCheck = checkouts.findIndex((el) => el.tr === "" || !el.tr);
      if (isCompleteCheck === -1) {
        return true;
      }
      return false;
    }
  };

  const checkComplete = () => {
    const updatedCheckOuts = [...checkouts];
    let pickIndex = 0;
    for (let i = 0; i < updatedCheckOuts.length; i++) {
      const upCheckout = updatedCheckOuts[i];
      pickIndex = upCheckout.checxkoutItems.findIndex((el) => el.picked === 0);
      if (pickIndex !== -1) {
        break;
      }
    }

    if (pickIndex === -1) {
      setRegistry({ ...registry, status: "PICK_COMPLETE" });
      pickComplete(true);
    } else {
      setRegistry({ ...registry, status: "PART_PICKED" });
      pickComplete(false);
    }
  };

  const packConfirmation = async () => {
    if (checkTrDetailsComplete()) {
      await setPacked();
    } else {
      setIsOpenConfirmPack(true);
    }
  };

  const setPacked = async () => {
    setIsOpenConfirmPack(false);
    const updatedReg = { ...registry };
    updatedReg.status = "PACKED";
    packed();
    setRegistry(updatedReg);
  };

  useEffect(() => {
    fetchData();
  }, [fetchData, id]);

  useEffect(() => {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    setDisabled(["PICK_COMPLETE", "PACKED", "SHIPPED", "CLOSE"].includes(registry.status));
    const twoDays = addDays(today, 2);
    setIsForPicking(isAfter(twoDays, new Date(registry.deliveryDate)));
  }, [registry]);

  const handleFilterEvent = async (evt) => {
    const { value } = evt.target;
    
    const checkoutss = await doFetchData()
    console.log('checkouts', checkouts)
    let filteredCheckoutItems = checkoutss.filter(
      (e) =>
        [e?.checkout?.order?.trackingNumber].includes(value) ||
        [e?.checkout?.order?.orderNumber].includes(value) ||
        (value === null || value === "")
    );
    setCheckouts(filteredCheckoutItems);
  };

  function useReload()  {
    const [reloading, setReloading] = useState(false);
    const reload = useCallback(() => {
      setReloading(true);
    }, [setReloading]);

    useEffect(() => {
      if (reloading) {
        setReloading(false);
      }
    }, [reloading, setReloading]);

    return [reload, reloading];
  }

  const [reload, reloading] = useReload();

  const triggerReload = () => {
    console.log('triggered')
    reload()
  }

  return (
    <Card className={classes.card} elevation={1}>
      <TextField 
        placeholder="Search for Order # / Tracking #" 
        fullWidth
        onChange={(evt) => handleFilterEvent(evt)}
        sx={{ width: 350, marginBottom: 2 }}
      ></TextField>
      <Button onClick={() => triggerReload()}>refresh</Button>
      {!reloading && checkouts && checkouts.length > 0 && (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell className={classes.tableIndex}>Order #</TableCell>
                <TableCell className={classes.tableIndex}>Tracking #</TableCell>
                <TableCell className={classes.tableIndex}>Date</TableCell>
                <TableCell className={classes.tableIndex}>Customer</TableCell>
                <TableCell className={classes.tableIndex}>Payment Type</TableCell>
                {/* <TableCell className={classes.tableIndex}>TR/TID</TableCell> */}
                <TableCell className={classes.tableIndex}>Shipping</TableCell>
                <TableCell className={classes.tableIndex}>Total Amount</TableCell>
                <TableCell className={classes.tableIndex}>Status</TableCell>
                <TableCell className={classes.tableIndex}>Online Barcode</TableCell>
                <TableCell className={classes.tableIndex}>Remarks</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {checkouts.map((checkout, idx) => (
                <Row
                  key={idx}
                  idx={idx}
                  checkoutRow={checkout}
                  pickComplete={pickComplete}
                  registry={registry}
                  setRegistry={setRegistry}
                  checkComplete={checkComplete}
                  reload={triggerReload}
                  doFetchData={doFetchData}
                  disabled={disabled}
                  giftWraps={giftWrapList}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <br />
      <br />
      <br />

      {/* { registry && ["PICK_COMPLETE"].includes(registry.status) && <div>
            <Button variant="contained" color="secondary" onClick={() => packConfirmation()} disabled={!isForPicking}>PACKED</Button> 
            {isForPicking ? null : <><br/><span style={{fontSize:12, color:"#858585"}}>Delivery Date is still more than 2 days to go</span></>}
        </div>} */}

      <Dialog open={isOpenConfirmPack} onClose={() => setIsOpenConfirmPack(false)}>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            There are still unposted orders. Would you like to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpenConfirmPack(false)} color="error">
            Cancel
          </Button>
          <Button onClick={() => setPacked()} color="secondary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default PickList;